import { render, staticRenderFns } from "./revenue-analysis.vue?vue&type=template&id=60d8df60&scoped=true&"
import script from "./revenue-analysis.vue?vue&type=script&lang=js&"
export * from "./revenue-analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8df60",
  null
  
)

export default component.exports